import trafficMessageStore from './store'

export default class TrafficMessageModule {
  name = 'trafficMessage'
  constructor({ store }) {
    store.registerModule(this.name, trafficMessageStore)
  }
}
